import React from 'react';
import Collapse from 'react-bootstrap/Collapse';

interface SummaryAccordionBlockBaseProps {
  open: boolean;
  onToggle: () => void;
  title: string;
  children: React.ReactNode;
  accordionPanelId?: string;
  cardClassName?: string;
  headerClassName?: string;
  badge?: string;
}

export type SummaryAccordionBlockProps = SummaryAccordionBlockBaseProps &
  ({ iconSrc: string; icon?: never } | { icon: string; iconSrc?: never });

const AccordionChevron: React.FC<{ expanded: boolean }> = ({ expanded }) => (
  <svg
    className="summary-accordion-chevron text-secondary flex-shrink-0"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-hidden
    focusable="false"
  >
    {expanded ? (
      <path fill="currentColor" d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z" />
    ) : (
      <path fill="currentColor" d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" />
    )}
  </svg>
);

const SummaryAccordionBlock: React.FC<SummaryAccordionBlockProps> = (props) => {
  const { open, onToggle, title, children, cardClassName, headerClassName, accordionPanelId, badge } =
    props;
  const panelId =
    accordionPanelId?.trim() ||
    `accordion-body-${title.replace(/\s+/g, '-').toLowerCase()}`;
  const headerClasses = ['accordion-section-toggle', headerClassName].filter(Boolean).join(' ');
  const cardClasses = ['card', 'border', 'mb-3', 'summary-accordion-card', cardClassName]
    .filter(Boolean)
    .join(' ');
  return (
    <div className={cardClasses}>
      <button
        type="button"
        className={`w-100 d-flex align-items-center justify-content-between btn text-left border-0 rounded-0 ${headerClasses}`}
        onClick={onToggle}
        aria-expanded={open}
        aria-controls={panelId}
        id={`${panelId}-toggle`}
      >
        <span className="d-flex align-items-center text-dark flex-grow-1 min-w-0">
          {'iconSrc' in props ? (
            <img
              src={props.iconSrc}
              alt=""
              aria-hidden
              className="summary-accordion-head-icon"
            />
          ) : (
            <span className="material-icons summary-accordion-head-icon text-secondary">
              {props.icon}
            </span>
          )}
          <span className="summary-accordion-title">{title}</span>
          {badge ? <span className="summary-accordion-badge">{badge}</span> : null}
        </span>
        <AccordionChevron expanded={open} />
      </button>
      <Collapse in={open}>
        <div id={panelId} role="region" aria-labelledby={`${panelId}-toggle`}>
          <div className="summary-accordion-body">{children}</div>
        </div>
      </Collapse>
    </div>
  );
};

export default SummaryAccordionBlock;
